// import { createReducer } from "@reduxjs/toolkit";

// const initialState = {
//   loading: false,
//   status: null,
//   message: null,
//   data: [],           // store sectors array here
//   categories: [],     // industry categories
//   categoriesLoading: false,
// };

// const sectorSmmReducer = createReducer(initialState, {
//   // --- Fetch sectors (SIC4 products) ---
//   SECTORS_REQ: (state) => {
//     state.loading = true;
//     state.data = [];
//   },
//  SECTORS_FETCH_SUC: (state, actions) => {
//   state.loading = false;
//   state.status = actions.payload.status;
//   state.message = actions.payload.message;
//   state.data = actions.payload.data?.data || []; // ✅ now this is the array
// },

//   SECTORS_ERROR: (state) => {
//     state.loading = false;
//     state.status = null;
//     state.message = null;
//     state.data = [];
//   },

//   // --- Category list actions ---
//   CATEGORIES_REQ: (state) => {
//     state.categoriesLoading = true;
//     state.categories = [];
//   },
//   CATEGORIES_FETCH_SUC: (state, actions) => {
//     state.categoriesLoading = false;
//     state.categories = actions.payload.data || [];
//   },
//   CATEGORIES_ERROR: (state) => {
//     state.categoriesLoading = false;
//     state.categories = [];
//   },
// });

// export default sectorSmmReducer;

import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  loaded: false,      // <-- add this
  status: null,
  message: null,
  data: [],           // sectors array
  categories: [],
  categoriesLoading: false,
};

// helper: normalize any payload shape to an array
const toArray = (p) => {
  const a =
    (Array.isArray(p) && p) ||
    (Array.isArray(p?.data) && p.data) ||
    (Array.isArray(p?.data?.data) && p.data.data) ||
    (Array.isArray(p?.results) && p.results) ||
    (Array.isArray(p?.items) && p.items) ||
    [];
  return a;
};

const sectorSmmReducer = createReducer(initialState, {
  // --- Fetch sectors ---
  SECTORS_REQ: (state) => {
    state.loading = true;
    // ❌ don't nuke existing data; keep it so UI can render something
    // state.data = [];
  },

  SECTORS_FETCH_SUC: (state, actions) => {
    state.loading = false;
    state.loaded = true;
    state.status = actions.payload?.status ?? null;
    state.message = actions.payload?.message ?? null;

    // ✅ normalize various payload shapes
    const arr =
      toArray(actions.payload) ||
      toArray(actions.payload?.data) ||
      toArray(actions.payload?.data?.data);

    state.data = arr;
  },

  SECTORS_ERROR: (state, actions) => {
    state.loading = false;
    state.loaded = false;
    state.status = null;
    state.message = actions.payload?.message || actions.error?.message || "Failed";
    // Optional: keep old data to avoid blank UI on transient failures
    // state.data = [];
  },

  // --- Category list actions ---
  CATEGORIES_REQ: (state) => {
    state.categoriesLoading = true;
    // keep existing categories until new ones arrive
  },
  CATEGORIES_FETCH_SUC: (state, actions) => {
    state.categoriesLoading = false;
    state.categories =
      actions.payload?.data ||
      actions.payload?.results ||
      actions.payload?.items ||
      [];
  },
  CATEGORIES_ERROR: (state) => {
    state.categoriesLoading = false;
    // keep old categories on error
  },
});

export default sectorSmmReducer;
